import "./ExtendedSearchDetails.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { ExtendedSearchDetailsComponentController } from "./ExtendedSearchDetailsComponentController";

export class ExtendedSearchDetailsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = ExtendedSearchDetailsComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/Search/ExtendedSearchDetails/ExtendedSearchDetails.html";
    }
}
